import type { LocationTreeNode } from '../api/schedulingApis';

export function isProjectRootNode(node: LocationTreeNode | null | undefined): boolean {
  if (!node) return false;
  if (node.location_level === 1) return true;
  const parent = node.parent_location_id;
  return parent == null || parent === '' || parent === 'null';
}

export function formatLocationTypeLabel(type: string): string {
  if (!type) return '';
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}

/**
 * Collapse runs of whitespace to a single space while typing.
 * Preserves a single trailing space so words can be separated normally.
 */
export function normalizeLocationNameInput(value: string): string {
  return value.replace(/\s+/g, ' ');
}

export function collectLocationTypes(nodes: LocationTreeNode[]): string[] {
  const set = new Set<string>();
  function walk(list: LocationTreeNode[]) {
    for (const n of list) {
      if (n.location_type) set.add(String(n.location_type).toLowerCase());
      if (n.child?.length) walk(n.child);
    }
  }
  walk(nodes);
  const out = Array.from(set).sort();
  return out.length ? out : ['project'];
}
